import { render, staticRenderFns } from "./setGetStaff.vue?vue&type=template&id=eadb72c4&scoped=true"
import script from "./setGetStaff.vue?vue&type=script&lang=js"
export * from "./setGetStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadb72c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eadb72c4')) {
      api.createRecord('eadb72c4', component.options)
    } else {
      api.reload('eadb72c4', component.options)
    }
    module.hot.accept("./setGetStaff.vue?vue&type=template&id=eadb72c4&scoped=true", function () {
      api.rerender('eadb72c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/components/setGetStaff.vue"
export default component.exports